import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_FUNCTION_URL, BASE_URL } from "../App";


export async function getDex(salesOrg: string,customer_num:string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      customer_num
    },
    url: `${BASE_URL}/api/telemeter/formated_dex`,
  };
  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export async function getDexdetals(salesOrg: string,id:any) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      id
    },
    url: `${BASE_URL}/api/telemeter/dexdetals`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export async function getTelemeterdata(salesOrg: string,plant:any) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      plant:plant[0]
    },
    url: `${BASE_URL}/api/telemeter/telemeterdashboard`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export interface salesOffice{
  city: string;
  code: string;
  sales_org: string;
  state: string;
  text: string;
  text_long: string;
}

export async function getPlants(salesOrg: string,is_all?:any): Promise<salesOffice[]> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      is_all:false
    },
      url: `${BASE_URL}/api/adminsettings/deliveryPlants`,
    };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}